import React from 'react';

/**
 * パートナー管理者が設定するヒーロー/ログインタイトルを安全に描画する。
 *
 * 唯一許可するマークアップは `<accent>...</accent>` のみ。以前は
 * `dangerouslySetInnerHTML` で文字列を HTML として挿入していたため、
 * パートナー管理者が `<img onerror=...>` 等を仕込むと、そのパートナーの
 * 全ユーザー(未認証のログイン画面含む)で実行される Stored XSS になっていた。
 *
 * ここでは accent トークンだけを `<span>` ノードに変換し、それ以外は
 * すべてプレーンテキスト(React が自動エスケープ)として描画するため、
 * 任意の HTML/スクリプトが注入されても文字列として表示されるだけになる。
 */

const ACCENT_RE = /<accent>([\s\S]*?)<\/accent>/g;

export function renderAccentText(
  raw: string,
  accent: { className?: string; style?: React.CSSProperties },
): React.ReactNode[] {
  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;

  // RegExp はグローバルなので lastIndex をリセットしてから使う。
  ACCENT_RE.lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = ACCENT_RE.exec(raw)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(raw.slice(lastIndex, match.index));
    }
    nodes.push(
      <span key={key++} className={accent.className} style={accent.style}>
        {match[1]}
      </span>,
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < raw.length) {
    nodes.push(raw.slice(lastIndex));
  }

  return nodes;
}
